// বাংলা সংখ্যা/তারিখ — UI-তে সবখানে বাংলা অঙ্ক, ডাটাবেসে যেমন আছে তেমনই থাকে।
const numberBn = new Intl.NumberFormat("bn-BD");
const dateBn = new Intl.DateTimeFormat("bn-BD", { year: "numeric", month: "long", day: "numeric" });

export function toBn(value) {
  const n = Number(value);
  return numberBn.format(Number.isFinite(n) ? n : 0);
}

export function formatDateBn(iso) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : dateBn.format(d);
}

// গত `days` দিনের মধ্যে যোগ হয়ে থাকলে "নতুন"
export function isRecent(iso, days = 7) {
  const t = new Date(iso).getTime();
  return Number.isFinite(t) && Date.now() - t < days * 86_400_000;
}

// শিক্ষকের নাম না দিলে ডাটাবেসের ডিফল্ট লেখা বসে — সেটা দেখানোর মতো তথ্য না
export const ANON_TEACHER = "নাম উল্লেখ করেননি";
export const teacherOf = (paper) => (paper?.teacher_name && paper.teacher_name !== ANON_TEACHER ? paper.teacher_name : "");
